import React from 'react';
import {fetchUpdates} from '../../data/fetch';
import Loader from './Loader';

const LoadUpdates = ({children}) => (
    <Loader promises={[fetchUpdates()]} skipSpinner>
        {children}
    </Loader>
);

export default LoadUpdates;
